import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'Deposit';

// TODO: Typa
export const getPdfByDepositId = (depositId: number) => {
  const endpoint = `${controller}/getPdf/${depositId}`;
  return AxiosInstance.get<any>(endpoint, { responseType: 'arraybuffer' });
};

export const downloadPdfByDepositId = (depositId: number) => {
  const endpoint = `${controller}/getPdf/${depositId}`;
  return AxiosInstance.get(endpoint, {
    responseType: 'blob', // VERY IMPORTANT
    headers: { Accept: 'application/pdf' },
  });
};

export const markAsHandled = (depositId: number) => {
  const endpoint = `${controller}/${depositId}/MarkAsHandled`;
  AxiosInstance.put(endpoint);
};
